import { Injectable } from '@angular/core';
import { SystemLog } from '@osos/shared/api';
import { SystemLogPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../../bases';

@Injectable()
export class SystemLogsParserV1Service extends ParserBase<
  SystemLog,
  SystemLogPresenterModel
> {
  constructor() {
    super(SystemLog, SystemLogPresenterModel, 1);
  }

  getPresenterModel(model: Partial<SystemLog>): SystemLogPresenterModel {
    return {
      id: model.id,
      details: model.details,
      doneAt: model.doneAt,
      doneBy: model.doneBy,
    };
  }
  getDataModel(presenter: SystemLogPresenterModel): SystemLog {
    return {
      id: presenter.id,
      details: presenter.details,
      doneAt: presenter.doneAt,
      doneBy: presenter.doneBy,
    };
  }
}
